<template>
    <transition
        :enter-active-class="transition.enter"
        :leave-active-class="transition.leave"
    >
        <!-- <div
            v-show="isActive"
            :class="['c-toast', `c-toast--${type}`, `c-toast--${position}`]"
            @mouseover="toggleTimer(true)"
            @mouseleave="toggleTimer(false)"
            @click="click"
            role="alert"
            v-html="message"
        /> -->
        <div
            v-show="isActive"
            :class="customClasses"
            class="pl-3.5 py-[11px] pr-[18px] border rounded-xl shadow-5 flex items-center justify-between gap-5"
            role="alert"
            @mouseleave="toggleTimer(false)"
            @mouseover="toggleTimer(true)"
        >
            <span>
                <span class="inline-block mr-4 align-middle">
                    <component :is="iconProvider"></component>
                </span>
                <span class="align-middle font-medium text-base-100">{{
                        message
                    }}</span>

                
            </span>
            <!-- <span
                class="inline-block align-middle cursor-pointer transition-all duration-300 ease-in-out scale-100 hover:scale-110"
                @click="click"
            >
                <svg
                    fill="none"
                    height="14"
                    viewBox="0 0 14 14"
                    width="14"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13 1L1 13M1 1L13 13"
                        stroke="#D92D20"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                    />
                </svg>
            </span> -->
        </div>
    </transition>
</template>

<script>
import SuccessSvg from "./icons/SuccessSvg.vue";
import InfoSvg from "./icons/InfoSvg.vue";
import WarnSvg from "./icons/WarnSvg.vue";
import ErrorSvg from "./icons/ErrorSvg.vue";
import { removeElement } from "./helpers/remove-element";
import Timer from "./helpers/timer";
import Positions, { definePosition } from "./defaults/positions";
import eventBus from "./helpers/event-bus";

export default {
    name: "Toast",
    components: {
        SuccessSvg,
        InfoSvg,
        WarnSvg,
        ErrorSvg
    },
    props: {
        message: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: "default"
        },
        position: {
            type: String,
            default: Positions.BOTTOM_RIGHT,
            validator(value) {
                return Object.values(Positions).includes(value);
            }
        },
        maxToasts: {
            type: [Number, Boolean],
            default: false
        },
        duration: {
            type: [Number, Boolean],
            default: 4000
        },
        dismissible: {
            type: Boolean,
            default: true
        },
        queue: {
            type: Boolean,
            default: false
        },
        pauseOnHover: {
            type: Boolean,
            default: true
        },
        useDefaultCss: {
            type: Boolean,
            default: true
        },
        onClose: {
            type: Function,
            default: () => {
            }
        },
        onClick: {
            type: Function,
            default: () => {
            }
        }
    },
    data() {
        return {
            isActive: false,
            parentBottom: null,
            isHovered: false,
            timer: null
        };
    },
    computed: {
        correctParent() {
            return definePosition(
                this.position,
                this.parentTop,
                this.parentBottom
            );
        },
        transition() {
            return definePosition(
                this.position,
                {
                    enter: "fadeInDown",
                    leave: "fadeOut"
                },
                {
                    enter: "fadeInUp",
                    leave: "fadeOut"
                }
            );
        },
        customClasses() {
            return {
                "bg-[#F6FEF9] border-[#12B76A]": this.type === "success",
                "bg-[#E5EFFA] border-[#006ADF]": this.type === "info",
                "bg-[#FEF7EA] border-[#EF9400]": this.type === "warning",
                "bg-[#F1E4E5] border-alert-red": this.type === "error"
            };
        },
        iconProvider() {
            if (this.type === "success") {
                return SuccessSvg;
            }
            if (this.type === "info") {
                return InfoSvg;
            }
            if (this.type === "warning") {
                return WarnSvg;
            }
            if (this.type === "error") {
                return ErrorSvg;
            }
        }
    },
    beforeMount() {
        this.createParents();
        this.setDefaultCss();
        this.setupContainer();
    },
    mounted() {
        this.showNotice();
        eventBus.$on("toast-clear", this.close);
    },
    beforeUnmount() {
        eventBus.$off("toast-clear", this.close);
    },
    methods: {
        createParents() {
            this.parentBottom = document.querySelector(".cpr-toast--bottom");

            if (this.parentBottom) return;

            if (!this.parentBottom) {
                this.parentBottom = document.createElement("div");
                this.parentBottom.className =
                    " fixed bottom-28 right-8  cpr-toast--bottom space-y-6";
                this.parentBottom.style.zIndex = "99999999";
            }
        },
        setDefaultCss() {
            const type = this.useDefaultCss ? "add" : "remove";
            this.parentBottom.classList[type]("v--default-css");
        },
        setupContainer() {
            const container = document.body;
            container.appendChild(this.parentBottom);
        },
        shouldQueue() {
            if (!this.queue && this.maxToasts === false) {
                return false;
            }

            if (this.maxToasts !== false) {
                return (
                    this.maxToasts <=
                    this.parentTop.childElementCount +
                    this.parentBottom.childElementCount
                );
            }

            return (
                this.parentTop.childElementCount > 0 ||
                this.parentBottom.childElementCount > 0
            );
        },
        showNotice() {
            if (this.shouldQueue()) {
                this.queueTimer = setTimeout(this.showNotice, 250);
                return;
            }

            this.correctParent.insertAdjacentElement("afterbegin", this.$el);
            this.isActive = true;

            this.timer =
                this.duration !== false
                    ? new Timer(this.close, this.duration)
                    : null;
        },
        // click() {
        //     this.onClick.apply(null, arguments);

        //     if (this.dismissible) {
        //         this.close();
        //     }
        // },
        toggleTimer(newVal) {
            if (this.timer && this.pauseOnHover) {
                newVal ? this.timer.pause() : this.timer.resume();
            }
        },
        stopTimer() {
            this.timer && this.timer.stop();
            clearTimeout(this.queueTimer);
        },
        close() {
            this.stopTimer();
            this.isActive = false;
            setTimeout(() => {
                this.onClose.apply(null, arguments);
                removeElement(this.$el);
            }, 150);
        }
    }
};
</script>
